"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_string_replace_1 = tslib_1.__importDefault(require("react-string-replace"));
// Matches <Element name="name">children</Element> and <Element name="name" />,
// extracting the full Element tag.
// Wrapping the pattern in a group is a requirement of `react-string-replace`.
var elementPattern = /(<Element name=['"][^'"]+?['"](?: ?\/>|>.*?<\/Element>))/g;
// Matches <Element name="name">children</Element> and <Element name="name" />,
// extracting the name and children as match groups.
var nameChildrenPattern = /<Element name=['"]([^'"]+?)['"](?: ?\/>|>(.*?)<\/Element>)/;
function renderMessage(message, values) {
    return (0, react_string_replace_1.default)(message, elementPattern, function (childElement, key) {
        var _a = childElement.match(nameChildrenPattern), name = _a[1], children = _a[2];
        var value = values === null || values === void 0 ? void 0 : values[name];
        if ((0, react_1.isValidElement)(value)) {
            // Value is a React element
            // Wrap it in a Fragment to ensure it has a key
            return (0, react_1.createElement)(react_1.Fragment, { key: key }, value);
        }
        if (typeof value === "function") {
            // Value is a React component
            return (0, react_1.createElement)(value, { key: key }, children);
        }
        // Value is a scalar
        return value;
    });
}
exports.default = renderMessage;
//# sourceMappingURL=renderMessage.js.map